import React from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { createEventId } from './event-utils'
import withClass from '../../../../hoc/withClass'
import styled from "@emotion/styled";
import {
  Box,
  Button,
  Grid,
  Paper,
  Stack,
  ThemeProvider,
  Typography,

} from '@mui/material'
import authContext from '../../../../context/auth-context'
import axios from 'axios'
import Spinner from '../../../UI/Spinner/Spinner';
import Modal from '../../../UI/Modal/CenterModal/CenterModalNew';
import AddEvent from './AddEvent/AddEvent';
import { useAlert } from 'react-alert'
import { confirmAlert } from 'react-confirm-alert'
import EditEvent from './EditEvent/EditEvent'
import { theme } from 'components/Content/Meetings/Main/Meeting/Details/InProgress/InprogressStepper'
import EditEventWindowDialog from './EditEvent/UI/EditEventWindowDialog'




export const StyleWrapper = styled.div`
.fc .fc-col-header-cell-cushion {
    padding-top: 0;
    padding-bottom: 0;
}
.fc .fc-button{
  /* needs to be same precedence */
  padding: 0 8px
}
.fc .fc-theme-standard td, .fc-theme-standard th{
  border: 1px solid var(--fc-border-color, #e1e1e1);
}
.fc .fc-event{
  font-weight: 400 !important
}
`

const CustomCalendar = () => {
  const currentEvents = React.useRef([]);
  const { accessToken, companyId, tokenIsValid } = React.useContext(authContext);
  const [editEvent, setEditEvent] = React.useState(null)
  const [openModal, setOpenModal] = React.useState(false);
  const [selectedDay, setSelectedDay] = React.useState(null);
  const calendar = React.useRef(null);
  const event = React.useRef(null);
  const [reloading, setReloading] = React.useState(false)
  const formRef = React.useRef(null);
  const [meeting, setMeeting] = React.useState(null);
  const [isLocked, setIsLocked] = React.useState(true)



  const alert = useAlert();
  // ================================== | EVENTS | ================================== //
  const move = async (id, body) => {
    return await axios.post(`/utilities/company-events/meeting/move/${id}`, body);
  };


  const newEventHandler = event => {
    axios.post('/utilities/company-events/meeting', event)
      .then(response => {
        // let title = prompt('Please enter a new title for your event')
        if (calendar.current) {
          const { message, data } = response.data;
          if (data && Array.isArray(currentEvents.current)) {
            let idList = currentEvents.current.map(a => a.id);
            let newId = Math.max(...idList) + 1;
            let calendarApi = calendar.current
            calendarApi.unselect() // clear date selection
            calendarApi.addEvent({
              id: newId,
              title: data.title,
              event_id: data.id,
              start: new Date(data.start),
              end: new Date(data.end),
              status: data.status,
              color: "#6c757d",
              allDay: false,
            });
          }
          alert.show(message, { type: 'success' });
          window.$('#newEventModal').modal('hide');
        }
      })
      .catch((error) => {
        console.log(error, "The error");
        alert.show("Failed to create event", { type: 'error' });
      })
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const events = React.useMemo(() => currentEvents.current, [reloading])

  const handleMove = ({ event, revert }, isResize) => {
      const start = new Date(event.start);
      const today = new Date()
      if (start.setHours(0, 0, 0, 0) - today.getTime() <= -127721479) {
        revert()
        return;
      }
      confirmAlert({
        customUI: ({ onClose }) => (
          <Paper
            sx={{
              minHeight: "max-content",
              maxWidth: 400,
              borderRadius: 2,
              padding: 4,
            }}
            elevation={1}
          >
            <Stack direction="column" spacing={2}>
              <Typography sx={{ fontFamily: 'inherit' }} variant="h5">{isResize ? `Change ${event.title} event time` : `Move ${event.title}`}</Typography>
              <Typography sx={{ fontFamily: 'inherit' }} variant="body">
                {isResize &&  'Change event time ?'} 
                {!isResize && `Move event to ${event.start.toDateString()} ?`}
              </Typography>
              <Stack direction="row" justifyContent="space-between" >
                <Button
                  variant="outlined"
                  color="error"
                  size='small'
                  onClick={() => {
                    revert();
                    onClose();
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  size="small"
                  onClick={() => {
                    // move(event.extendedProps.event_id, { startDate: event.start, endDate: event.end })
                    //   .then((res) => {
                    //     if (res.data) {
                    //       console.log("Test", res.data)
                    //       onClose();
                    //       alert.show(`${event.title} moved to ${event.start.toDateString()}`, { type: "success" })
                    //     } else {
                    //       revert();
                    //       onClose();
                    //     }
                    //   })
                    //   .catch(() => {
                    //     revert();
                    //     onClose();
                    //   })
                    move(event.extendedProps.event_id, {
                      startDate: event.start,
                      endDate: event.end,
                    })
                      .then((res) => {
                        if (res.data) {
                          onClose();
                          alert.show(`${event.title} moved to ${event.start.toDateString()}`, {
                            type: "success",
                          });
                        } else {
                          revert();
                          onClose();
                        }
                      })
                      .catch(() => {
                        revert();
                        onClose();
                      });
                  }}
                >
                  {isResize ? "Change Time": "Move"}
                </Button>
              </Stack>
            </Stack>
          </Paper>
        ),
        closeOnEscape: false,
        closeOnClickOutside: false,
        overlayClassName: "react-confirm-alert-custom-overlay",
      });
  }
  React.useEffect(() => {
    if (tokenIsValid) {
      setReloading(true)
      const response = axios.get('utilities/company-events');
      response.then(res => {
        let events = [];
        const { data } = res;
        if (Array.isArray(data)) {
          //console.log(data, "event");
          events = [...data?.map((event, index) => {

            return {
              id: index + 1,
              event_id: event.id,
              title: event.title,
              start: new Date(event.start),
              end: new Date(event.end),
              color: event.statusColor,
              status: event.status
            }
          }
          )];
        }
        currentEvents.current = [...events]
        setReloading(false)
      }).catch(err => console.log('ERROR'))
    }
    else {
      currentEvents.current = []
    }
    return () => {
      setEditEvent(null)
      currentEvents.current = []
    }
    // return () => onResetEvents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken, companyId, tokenIsValid]);

  const handleDateSelect = (selectInfo) => {
    const today = new Date();
    if (Math.sign(selectInfo.start.getTime() - today.getTime() + 84400000) === -1) return;
    calendar.current = selectInfo.view.calendar
    window.$('#newEventModal').modal('show')
    setSelectedDay(selectInfo.start)
  }

  React.useEffect(() => {
    if (editEvent && openModal && event.current)
      window.$('#editEventModal').modal('show')
  }, [editEvent, openModal])

  const handleEventClick = (clickInfo) => {
    const eventObj = {
      id: createEventId(),
      event_id: clickInfo.event.extendedProps.event_id,
      title: clickInfo.event.title,
      start: clickInfo.event.start,
      end: clickInfo.event.end,
      allDay: false
    }
    event.current = clickInfo.event

    setEditEvent(eventObj);
    setOpenModal(true)
    // clickInfo.event.remove()
  }




  const handleEvents = (events) => {
    currentEvents.current = [...events]
  }
  const renderEventContent = (eventInfo) => {
    return (
      <Grid container direction="row">
        <Grid item xs={4}>
          <Typography sx={{ fontFamily: 'inherit' }}
            color="common.white"
            noWrap
            variant='inherit'
          >
            {eventInfo.timeText + "m"}
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography sx={{ fontFamily: 'inherit' }}
            color="common.white"
            noWrap
            variant='inherit'
          >
            {eventInfo.event.title}
          </Typography>
        </Grid>
      </Grid>

      // <>
      //   <b>{eventInfo.timeText + " "+ eventInfo.event.title}</b>
      // </>
    )
  }

  return (
    <ThemeProvider theme={theme}>

      {!reloading ?
        <div style={{ padding: '30px 10px 10px' }}>
          <StyleWrapper>
            <FullCalendar
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              headerToolbar={{
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay'
              }}
              height="80vh"
              initialView='dayGridMonth'
              editable={true}
              selectable={true}
              selectMirror={false}
              dayMaxEvents={true}
              events={events} // alternatively, use the `events` setting to fetch from a feed
              select={handleDateSelect}
              businessHours
              eventContent={renderEventContent} // custom render function
              eventClick={handleEventClick}
              eventDidMount={(info) => {
                switch (info.event.extendedProps.status) {
                  case "Upcoming":
                  case "Postponed":
                    info.el.style.background = "#3177ad"
                    info.el.style.borderColor = "#3177ad"
                    break;
                  case "Draft":
                    info.el.style.background = "#6c757d"
                    info.el.style.borderColor = "#6c757d"
                    break;
                  case "In-progress":
                    info.el.style.background = "#dea704"
                    info.el.style.borderColor = "#dea704"
                    break;
                  case "Completed":
                    info.el.style.background = "#28a745"
                    info.el.style.borderColor = "#28a745"
                    break;
                  case "Virtual":
                  case "Virtual/Hybrid":
                  case "Hybrid":
                    info.el.style.background = "#17a2b8"
                    info.el.style.borderColor = "#17a2b8"
                    break;
                  default:
                    info.el.style.background = "#6c757d"
                    info.el.style.borderColor = "#6c757d"
                    break;
                }
                //console.log(info.event.extendedProps.status, info, "Ifo status")
                //info.el.style.border = info.event.backgroundColor
              }}
              eventsSet={handleEvents} // called after events are initialized/added/changed/removed
              eventResize={(info) => handleMove(info, true)}
              eventDrop={(info) => handleMove(info, false)}

            />
          </StyleWrapper>
          <Modal modalId="newEventModal" modalTitle={`New Event`}>
            <AddEvent
              createHandler={data => { newEventHandler(data); window.$('#newEventModal').modal('hide'); }}
              eventDate={selectedDay}
            />
          </Modal>
          <EditEventWindowDialog
            open={openModal}
            setOpen={setOpenModal}
            formRef={formRef}
            meeting={meeting}
            isLocked={isLocked}
            setIsLocked={setIsLocked}
          >
            {(editEvent && event.current)
              &&
              <EditEvent
                editEvent={editEvent}
                event={event}
                formRef={formRef}
                setOpenModal={setOpenModal}
                meeting={meeting}
                setMeeting={setMeeting}
                isLocked={isLocked}
              />}
          </EditEventWindowDialog>
        </div>
        :
        <Box height='80vh' width='100%'>
          <Spinner module='calendar' />
        </Box>
      }
    </ThemeProvider>

  )
}


export default withClass(CustomCalendar, 'page-main');